import call from "@/conn-global/api";

export default {
  // getApiExample: ({ commit }) => {
  //   call
  //     .get("https://api.coindesk.com/v1/bpi/currentprice.json")
  //     .then((res) => {
  //       if (res != undefined) {
  //         commit("ubahNama", res.status);
  //       }
  //       return console.log(res);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // },

  getDataDashboard: async ({ commit }) => {
    let response = await call.get("/v1/dashboard/get-dashboard").then((res) => {
      if (res !== undefined) {
        commit("addDataDashboard", res.data.data);
        return res;
      }
      return res;
    });
    return response;
  },

  postSendOtp: async ({ commit }, data) => {
    let response = await call
      .post("/v1/auth/request_otp", data, false)
      .then((res) => {
        commit("addDataOtp", res);
        return res;
      })
      .catch((err) => {
        console.log(err);
      });
    return response;
  },

  getDataLayanan: ({ commit }, idcutomer) => {
    call
      .get("/v1/akun/get_akun/" + idcutomer)
      .then((res) => {
        if (res != undefined) {
          commit("addDataLayanan", res);
        }
        // return console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
